import { createSelector } from 'reselect';

import { selectVideo } from './videoPlayer';

export const selectCommentsEnabled = createSelector(
  selectVideo,
  video => video.comments_enabled
);

export const selectRecordReplyEnabled = createSelector(
  selectVideo,
  video => video.record_reply_enabled
);

export const selectEmojiEnabled = createSelector(
  selectVideo,
  video => video.use_emojis
);

export const selectCommentsOrEmojiEnabled = createSelector(
  selectCommentsEnabled,
  selectEmojiEnabled,
  (commentsEnabled, emojiEnabled) => commentsEnabled || emojiEnabled
);

export const selectOwnerName = createSelector(
  selectVideo,
  video => video.owner_name
);
